import React from 'react';
import { Route, Routes } from 'react-router-dom';
import WelcomeTopic from './topics/start';
import TopicSso from './topics/sso';
import TopicPyde from './topics/pyde';
import TopicPypi from './topics/pypi';
import TopicAIns from './topics/AIns';
import TopicCtis from './topics/ctis';
import TopicQuiz from './topics/topicQuiz';
import './index.less';
import './index.mobile.less';
import './index.en.less';

export interface IGeneralStaffProps {
  topicName: string;
  topicSettings: any;
}

export function StudentTraining(props: IGeneralStaffProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/welcome"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/pyde"
        element={<TopicPyde settings={props.topicSettings} />}
      />
      <Route
        path="/sso"
        element={<TopicSso settings={props.topicSettings} />}
      />
      <Route
        path="/pypi"
        element={<TopicPypi settings={props.topicSettings} />}
      />
      <Route
        path="/AIns"
        element={<TopicAIns settings={props.topicSettings} />}
      />
      <Route
        path="/ctis"
        element={<TopicCtis settings={props.topicSettings} />}
      />
      <Route
        path="/quiz"
        element={<TopicQuiz settings={props.topicSettings} />}
      />
    </Routes>
  );
}
